import { Modal, Text } from 'ui';

interface IProps {
  onRequestClose: () => void;
  isOpen: boolean;
}

// TODO: remove after implementing mobile-first design
export const MobileUnsupportedModal = ({ onRequestClose, isOpen }: IProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      variant="center"
      contentLabel="threadsSupport"
      name="Mobile Device Issue"
    >
      <div>
        <Text size="md">Device not supported.</Text>
        <br />
        <Text size="md">
          The software platform is optimized for desktop displays. <br />
          We recommend switching to a larger screen for the best experience. <br />
          Mobile optimization is coming to Threads soon.
        </Text>
      </div>
    </Modal>
  );
};
